import React, { useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import { ArrowUpRight } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';
import api from '../../../services/api';

interface Step1EmailProps {
  onComplete: (email: string) => void;
}

const Step1Email: React.FC<Step1EmailProps> = ({ onComplete }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [emailError, setEmailError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setEmailError('');

    // Custom validation
    if (!email) {
      setEmailError('Email is required');
      return;
    }

    // Basic email format validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailError('Please enter a valid email address');
      return;
    }

    setLoading(true);

    try {
      const response = await api.post<{message: string; email: string; code?: string}>('/api/register/send-code', { email });
      
      if (response.code) {
        console.log('Verification code (dev only):', response.code);
      }

      onComplete(email);
    } catch (err: any) {
      if (err.response?.data?.error) {
        const errorMsg = err.response.data.error;
        if (errorMsg.toLowerCase().includes('email') || errorMsg.toLowerCase().includes('invalid') || errorMsg.toLowerCase().includes('already')) {
          setEmailError(errorMsg);
        } else {
          setError(errorMsg);
        }
      } else {
        setError('Failed to send verification code. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <h1 className="text-center">Register for Revealer</h1>
      <h2 className="text-center text-muted mb-4">Create your account to get started</h2>

      {error && <Alert variant="danger">{error}</Alert>}

      <Form onSubmit={handleSubmit} noValidate>
        <Form.Group className="mb-3">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            placeholder="name@example.com"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setEmailError('');
            }}
            autoFocus
            isInvalid={!!emailError}
          />
          {emailError && (
            <Form.Text className="text-danger form-error-text">
              {emailError}
            </Form.Text>
          )}
        </Form.Group>

        <Button 
          type="submit" 
          className="w-100 mb-3"
          disabled={loading}
        >
          {loading ? 'SENDING...' : 'REGISTER'}
        </Button>
      </Form>

      <div className="text-center">
        <h2>Have an account? &nbsp;<Link to="/signin">SIGN IN</Link> <ArrowUpRight className="me-2" /></h2>
      </div>
    </>
  );
};

export default Step1Email;